import { ThemeUIProvider, Theme } from 'theme-ui';
import { ReactNode } from 'react';
import { getMainTheme } from './getMainTheme';

interface TThemeProvider {
  children: ReactNode;
  customTheme?: () => Theme;
}

export const CustomThemeProvider = ({
  children,
  customTheme,
}: TThemeProvider) => {
  const theme: Theme = getMainTheme(customTheme);

  return <ThemeUIProvider theme={theme}>{children}</ThemeUIProvider>;
};
